import { FieldTypes } from '../../../constants/FieldTypes'
import { addFieldRow } from '../../../fields'
import { DropdownField, ExamSectionField, FieldMap, TextAreaField } from '../../../types'
import { LochiaAmount, LochiaType } from '../types/postpartum'

const lochiaType: DropdownField<LochiaType> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Lochia Type',
  options: [
    { id: 'rubra', text: 'Rubra' },
    { id: 'serosa', text: 'Serosa' },
    { id: 'alba', text: 'Alba' },
    { id: 'not-applicable', text: 'N/A' },
  ],
}

const lochiaAmount: DropdownField<LochiaAmount> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Lochia Amount',
  options: [
    { id: 'none', text: 'None' },
    // { id: 'spotting', text: 'Spotting' },
    { id: 'light', text: 'Light' },
    { id: 'moderate', text: 'Moderate' },
    { id: 'heavy', text: 'Heavy' },
  ],
}

const lochia: FieldMap = {
  name: 'Lochia',
  children: {
    type: addFieldRow(lochiaType, { index: 0, flex: 1 }),
    amount: addFieldRow(lochiaAmount, { index: 0, flex: 1 }),
  },
}

const fundus: TextAreaField = {
  type: FieldTypes.TEXTAREA,
  placeholder: 'Fundus',
}

const perineum: ExamSectionField = {
  type: FieldTypes.EXAM_SECTION,
  placeholder: 'Perineum',
  optional: true,
}

export const postpartumExamField: FieldMap = {
  name: 'Postpartum Visit',
  children: { lochia, fundus, perineum },
}
